import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ServerDataResponse } from '@models/models';
import { Observable } from 'rxjs/Observable';
import { DoubleBooking, EventTimePayload } from '@models/double-booking.model';

@Injectable()
export class DoubleBookingDataService {
	constructor(private http: HttpClient) {}

	getOverlappingEvents(
		timeData: EventTimePayload,
		type?: 'JOB' | 'EVENT',
		id?: number
	): Observable<ServerDataResponse<DoubleBooking>> {
		let url = '/api/user/calendar-events/overlapping';

		if (type === 'EVENT' && id) {
			url = `/api/user/calendar-events/${id}/overlapping`;
		}

		if (type === 'JOB' && id) {
			url = `/api/user/v1/job/${id}/calendar-events/overlapping`;
		}

		return this.http.post(url, timeData) as Observable<
			ServerDataResponse<DoubleBooking>
		>;
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./shared/services/double-booking/double-boooking.data.service.ts